import UnitPlanDetails from "UnitPlanDetails";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearlyInsight from "./routes/YearlyInsight";
export default store => ({
  path: "yearly",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-scheduler" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [YearlyInsight(store), UnitPlanDetails(store)],
});
